// extracted by mini-css-extract-plugin
export var header = "header-module--header---cVP9";
export var inner = "header-module--inner--tq1mQ";
export var jsAnimInit = "header-module--jsAnimInit--127G1";
export var subtitle = "header-module--subtitle--1ZRsE";